import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const STR = {
  en: {
    // nav
    nav_how: "How it works",
    nav_services: "Services",
    nav_trust: "Trust",
    nav_cities: "Cities",
    nav_partner: "For Business",
    nav_faq: "FAQ",
    book: "Book a CHELA",
    whatsapp: "WhatsApp Us",
    how_it_works: "How it works",
    tell_us: "Tell us what you need",

    // hero
    hero_badge: "Now live in Bhopal",
    hero_h1: "Need a helping hand?\nBook a CHELA.",
    hero_sub: "An ID-verified local helper in Bhopal for personal assistance, family help, errands, light home help and events. ₹99 per hour, 1-hour minimum.",
    hero_example: "Bank, bill and post-office errands while you're at work, 1 hour: ₹99. You stay focused, we take care of it.",
    hero_wa_cta: "Book in 1 minute. Pay online and your CHELA comes to your doorstep.",
    hero_note: "From market shopping to festival chaos, moving things at home to helping your family \u2014 CHELA connects you with a reliable local helper when you need an extra pair of hands.",
    starting_from: "Starting at",
    per_hour: "/hour",
    offer_line: "First booking: 1st hour FREE on 2+ hours",
    diwali_price: "Diwali festival price: just ₹99/hour",
    qr_open: "Pay by scanning a QR (from another phone)",
    qr_title: "Scan & pay",
    qr_hint: "Open any UPI app (PhonePe, Google Pay, Paytm, BHIM) on any phone and scan this code.",
    qr_wait: "Waiting for payment… this confirms by itself",
    qr_hint_link: "Scan with the camera of any other phone, then pay with UPI, card or netbanking.",
    tr_title: "Travel charge",
    tr_note: "₹3 per km when you take your CHELA to another place. The full amount goes to your CHELA.",
    tr_paid: "Travel charge paid. Thank you!",
    tr_bad: "This travel payment link is not valid.",
    rv_eyebrow: "Real people, real words",
    rv_customer_h: "Mr. P.K. Agarwal, our first customer",
    rv_customer_p: "\"I booked yesterday and the CHELA arrived before time. The rate felt economical too. All the best!\"",
    rv_worker_h: "Suraj, after his first CHELA job",
    rv_worker_p: "\"No problem, no pressure. The money for two hours was top-notch. I will bring my friends too.\"",
    offer_first: "Your first booking (1st hour free)",
    offer_applied: "First booking offer applied: 1st hour free",
    jingle_on: "Sound on",
    jingle_off: "Sound off",

    // problem
    problem_eyebrow: "The idea",
    problem_h2: "Some things are too small for a full-time helper.",
    problem_p: "But too much to manage alone. Work is busy. A parcel needs collecting. The house needs a quick tidy before guests. You needed someone for two hours. That's where CHELA comes in.",
    problem_line: "Don't struggle. Don't ask five people. Just book a CHELA.",

    // situations
    sit_eyebrow: "Sound familiar?",
    sit_h2: "We've all needed one.",

    // services
    srv_eyebrow: "What you can book",
    srv_h2: "Human help, sorted into simple categories.",
    srv_p: "Not a giant complicated catalogue. Pick what fits \u2014 or just describe your task.",
    srv_cta: "Tell us what you need",

    // festival
    fest_eyebrow: "Festivals, functions & guests",
    fest_h2: "This festival, don't do it all alone.",
    fest_p: "Decoration, guests at home, puja and function help, last-minute errands and family help. Book a CHELA by the hour.",

    // how
    how_eyebrow: "How CHELA works",
    how_h2: "Four steps. That's it.",
    how_1_t: "Tell us what you need",
    how_1_d: "Choose a service or simply describe your task.",
    how_2_t: "Choose your time & pay",
    how_2_d: "Pick a slot and pay online. Your address is picked up automatically and the booking is confirmed instantly.",
    how_3_t: "We match you",
    how_3_d: "A suitable CHELA is assigned based on availability and task.",
    how_4_t: "Get it done",
    how_4_d: "Your CHELA helps you get the task done.",

    // trust
    trust_eyebrow: "Trust & safety",
    trust_h2: "People you can trust.",
    trust_p: "You're inviting a person into your home or family. We take that seriously — every CHELA is verified before their first job.",
    soon: "Launching Soon",
    live_label: "Live",
    never_title: "A CHELA will never:",
    never_1: "Handle your cash or UPI PIN",
    never_2: "Enter private rooms",
    never_3: "Share your number or address",
    never_4: "Give medical care",
    never_allow: "A CHELA enters only the areas you allow.",
    trust_i1: "ID, selfie and reference verified",
    trust_i2: "Clear, transparent pricing",
    trust_i3: "Booking confirmation",
    trust_i4: "Customer support contact",
    trust_i5: "Background verification",
    trust_i6: "Ratings & reviews system",
    trust_note: "Every CHELA is verified with ID, selfie, a local reference and a background check before their first job.",
    flow_1: "Book & share location",
    flow_2: "Pay online (UPI / card)",
    flow_3: "CHELA arrives",
    flow_4: "Task done, rate your CHELA",
    unmute: "Tap to unmute",

    // pricing
    pr_eyebrow: "Pricing",
    pr_h2: "Simple, honest pricing.",
    pr_first_hour: "first hour",
    pr_then: "then",
    pr_note: "The first hour covers your helper's travel and setup, so extra hours cost less.",
    pr_calc_title: "Price calculator",
    pr_plan: "Plan",
    pr_hours: "Hours",
    pr_total: "Estimated total",
    pr_standard: "Standard",
    why_eyebrow: "Why CHELA",
    why_h2: "Why choose CHELA",
    stock_note: "Representative stock footage, not real customers or helpers.",
    seehow_h2: "See how it works",
    pain_1_t: "Personal assistance",
    pain_1_d: "",
    why_1_t: "Personal assistance",
    why_1_d: "Your own helper for a few hours: tasks, follow-ups, pick-ups and anything you can't get to.",
    why_2_t: "Family help",
    why_2_d: "An extra pair of hands for your household: guests, errands, pick-ups and anything you're too busy to handle.",
    why_3_t: "Errands",
    why_3_d: "Queues, bills, documents, parcels and pick-up/drop, done while you stay at work or home.",
    why_4_t: "Light home help",
    why_4_d: "Light dusting of fans and shelves, rearranging, waiting for a delivery or repair person. No house cleaning.",
    no_cleaning: "House cleaning (sweeping, mopping, bathroom, kitchen, utensils).",
    not_included: "Not included",
    why_5_t: "Events & functions",
    why_5_d: "Extra hands for pujas, birthdays and small functions: setup, guests and running around.",
    pain_1_d: "Your CHELA carries every bag while you keep shopping.",
    pain_2_t: "Too many shops in one day",
    pain_2_d: "Your CHELA walks with you store to store and keeps purchases organised.",
    pain_3_t: "Too busy at work to run around",
    pain_3_d: "Your CHELA handles the bank, bills, parcels and queues while you get on with your day.",
    pr_rule_1: "Minimum booking is 1 hour",
    pr_rule_2: "Free cancellation up to 3 hours before the booking",
    pr_rule_3: "Waiting time is billed",
    pr_rule_4: "Taking your CHELA to another place? Travel is ₹3 per km, paid online",

    // b2b
    b2b_eyebrow: "For business",
    b2b_h2: "Businesses, we can help your customers too.",
    b2b_p: "Your customers leave with 5 to 10 bags and still have more shops to visit. Offer 'Shop with a CHELA' at no cost to you. We can share a small referral fee on every booking from your store.",
    f_shop: "Shop name",
    f_owner: "Owner name",
    f_area: "Market / area",
    b2b_cta: "Become a CHELA Partner",
    b2b_benefit: "Partner benefits can include referral support, customer convenience and dedicated assistance options.",

    // cities
    city_eyebrow: "City availability",
    city_h2: "Coming to more cities.",
    city_p: "We're starting in Bhopal and expanding city by city. Not in your city yet? Join the waitlist \u2014 it helps us launch where demand is real.",
    join_waitlist: "Join the waitlist",

    // faq
    faq_eyebrow: "Questions",
    faq_h2: "Good to know.",

    // final cta
    final_h2: "Got something to get done?",
    final_p: "Get a CHELA.",

    // footer
    foot_tag: "Your extra pair of hands.",
    foot_rights: "CHELA. Now live in Bhopal.",
    foot_join: "Work with CHELA",
    foot_address: "CHELA, Bhopal, Madhya Pradesh",
    foot_disclaimer: "CHELA provides light, non-medical local help. We are not a packers-and-movers, courier, nursing, security or taxi service, and we do not do house cleaning, painting or deep cleaning.",
    terms: "Terms",
    privacy: "Privacy",
    safety: "Safety & Disclaimer",

    // booking form
    bk_title: "Book a CHELA",
    s_what: "What do you need?",
    s_when: "When?",
    s_where: "Where & who?",
    d_today: "Today",
    d_tomorrow: "Tomorrow",
    d_other: "Other date",
    t_exact: "Pick your exact hour (or keep any time in this slot)",
    t_any: "Any time in this slot",
    slot_pick: "Pick a time",
    f_more: "+ Add email, referral code or city (optional)",
    f_less: "Hide optional details",
    bk_sub: "Book in 1 minute. Pay online and your CHELA comes to your doorstep.",
    f_city: "City",
    f_service: "Service",
    f_desc: "Tell us what you need",
    f_desc_ph: "e.g. Go with my father to the bank, then collect a parcel",
    f_date: "Date",
    f_time: "Time slot",
    f_duration: "Duration",
    f_location: "Your address",
    f_location_ph: "House no., street, landmark, area (e.g. Arera Colony)",
    f_name: "Your name",
    f_phone: "Phone number",
    f_email: "Email for receipt (optional)",
    f_email_ph: "you@email.com",
    f_ref: "Store / referral code (optional)",
    f_ref_ph: "e.g. SAREE-1A2B",
    f_select: "Select",
    submit_book: "Pay & book",
    pay_note: "Prepaid booking. Pay by UPI (PhonePe, Google Pay, Paytm), card or netbanking.",
    pay_opening: "Opening payment…",
    pay_pending: "Payment not completed. Your booking is confirmed only after payment. Tap Pay & book to try again.",
    loc_btn: "Detect my location",
    loc_busy: "Detecting your location…",
    loc_ok: "Location detected",
    loc_view: "View on map",
    loc_again: "Update",
    loc_err: "Could not get your location. Please allow location access or type your address.",
    loc_need: "Please allow location access or type your address.",
    ty_title: "Thank you for booking a CHELA!",
    ty_sub: "Your payment is received and your booking is confirmed. Your CHELA will reach your location at the chosen time.",
    ty_paid: "Amount paid",
    ty_when: "When",
    ty_ref: "Booking ID",
    ty_wa: "Chat with us on WhatsApp",
    ty_track: "Track your CHELA",
    bk_success: "Request received. We'll confirm your CHELA on WhatsApp shortly. Your booking is not confirmed until we message you.",
    bk_estimate: "Estimated amount:",
    pay_now: "Pay now",
    paylink_title: "Complete your CHELA booking",
    paylink_paid: "Payment received. Your booking is confirmed.",
    paylink_expired: "This time slot is over. Please book a new slot.",
    paylink_bad: "This payment link is not valid.",
    pay_pending_title: "Payment pending — your CHELA is NOT booked yet. Pay now to confirm.",
    bk_rules: "Free cancellation up to 3 hours before. Waiting time is billed. Taking your CHELA to another place costs ₹3 per km, paid online.",
    slot_hint: "Choose a date first, then a time slot.",
    slot_soon: "Slots that are already over today are greyed out.",
    other_city: "Not in Bhopal? Join the waitlist",
    phone_err: "Enter a valid 10-digit Indian mobile number",
    link_terms: "Terms",
    link_privacy: "Privacy",
    continue_wa: "Continue on WhatsApp",
    bk_only_bhopal: "We're live in Bhopal. For other cities, join the waitlist below.",

    // waitlist
    wl_title: "Join the city waitlist",
    wl_use: "What would you use CHELA for?",
    wl_submit: "Join waitlist",
    wl_success: "You're on the list! We'll reach out when CHELA reaches your city.",

    // partner page
    pt_title: "Become a CHELA Partner",
    pt_sub: "Your customers leave with 5 to 10 bags and still have more shops to visit. Offer 'Shop with a CHELA' at no cost to you. We can share a small referral fee on every booking from your store.",
    f_business: "Business name",
    f_biz_type: "Business type",
    f_contact: "Contact person",
    f_message: "Message (optional)",
    pt_submit: "Send partner enquiry",
    pt_success: "Thanks! We'll be in touch about partnering.",

    required: "This field is required",
    consent_err: "Please tick the box to agree to the Terms and Privacy Policy",
    back_home: "Back to home",
    install_title: "Add CHELA to your home screen",
    install_sub: "Book an extra pair of hands in one tap.",
    install_btn: "Install CHELA",
    install_ios: "Tap the Share icon, then \u2018Add to Home Screen\u2019.",
  },

  hi: {
    nav_how: "कैसे काम करता है",
    nav_services: "सर्विसेज़",
    nav_trust: "ट्रस्ट",
    nav_cities: "शहर",
    nav_partner: "बिज़नेस के लिए",
    nav_faq: "FAQ",
    book: "CHELA बुक करें",
    whatsapp: "WhatsApp करें",
    how_it_works: "कैसे काम करता है",
    tell_us: "बताइए क्या चाहिए",

    hero_badge: "अब भोपाल में लाइव",
    hero_h1: "मदद चाहिए?\nCHELA बुक करें।",
    hero_sub: "भोपाल में पर्सनल असिस्टेंस, परिवार की मदद, ज़रूरी काम, घर की हल्की मदद और इवेंट्स के लिए ID-वेरिफ़ाइड लोकल हेल्पर। ₹99 प्रति घंटा, कम से कम 1 घंटा।",
    hero_example: "ऑफिस के दौरान बैंक, बिल और पोस्ट-ऑफिस के काम, 1 घंटा: ₹99। आप अपना काम करें, हम संभाल लेंगे।",
    hero_wa_cta: "1 मिनट में बुक करें। ऑनलाइन पेमेंट करें और आपका CHELA आपके दरवाज़े पर पहुँचेगा।",
    hero_note: "बाज़ार की शॉपिंग से त्योहार की भागदौड़ तक, घर में सामान हटाने से परिवार की मदद तक \u2014 CHELA आपको एक भरोसेमंद लोकल मददगार से जोड़ता है।",
    starting_from: "शुरुआत",
    per_hour: "/घंटा",
    offer_line: "पहली बुकिंग: 2+ घंटे पर पहला घंटा FREE",
    diwali_price: "दिवाली फ़ेस्टिवल प्राइस: सिर्फ़ ₹99/घंटा",
    qr_open: "QR स्कैन करके पेमेंट करें (दूसरे फ़ोन से)",
    qr_title: "स्कैन करें और पेमेंट करें",
    qr_hint: "किसी भी फ़ोन पर कोई भी UPI ऐप (PhonePe, Google Pay, Paytm, BHIM) खोलें और यह कोड स्कैन करें।",
    qr_wait: "पेमेंट का इंतज़ार… यह अपने आप कन्फ़र्म हो जाएगा",
    qr_hint_link: "किसी दूसरे फ़ोन के कैमरे से स्कैन करें, फिर UPI, कार्ड या नेटबैंकिंग से पेमेंट करें।",
    tr_title: "ट्रैवल चार्ज",
    tr_note: "CHELA को दूसरी जगह ले जाने पर ₹3 प्रति किमी। पूरी रकम आपके CHELA को मिलती है।",
    tr_paid: "ट्रैवल चार्ज मिल गया। धन्यवाद!",
    tr_bad: "यह ट्रैवल पेमेंट लिंक सही नहीं है।",
    rv_eyebrow: "असली लोग, असली बातें",
    rv_customer_h: "श्री पी.के. अग्रवाल, हमारे पहले ग्राहक",
    rv_customer_p: "\"कल बुक किया और CHELA समय से पहले आ गया। रेट भी किफ़ायती लगा। ऑल द बेस्ट!\"",
    rv_worker_h: "सूरज, अपने पहले CHELA जॉब के बाद",
    rv_worker_p: "\"न कोई परेशानी, न कोई दबाव। दो घंटे के पैसे एक नंबर थे। मैं बाकी लोगों को भी जोड़ूँगा।\"",
    offer_first: "आपकी पहली बुकिंग (पहला घंटा फ्री)",
    offer_applied: "पहली बुकिंग ऑफ़र लागू: पहला घंटा फ्री",
    jingle_on: "आवाज़ चालू",
    jingle_off: "आवाज़ बंद",

    problem_eyebrow: "आइडिया",
    problem_h2: "कुछ काम फ़ुल-टाइम हेल्पर के लिए बहुत छोटे हैं।",
    problem_p: "पर अकेले संभालना मुश्किल। ऑफिस का काम बहुत है। एक पार्सल लाना है। मेहमानों से पहले घर ठीक करना है। दो घंटे के लिए कोई चाहिए था। यहीं CHELA काम आता है।",
    problem_line: "परेशान मत हों। पाँच लोगों से मत पूछें। बस एक CHELA बुक करें।",

    sit_eyebrow: "जाना-पहचाना लगता है?",
    sit_h2: "हम सबको कभी न कभी ज़रूरत पड़ी है।",

    srv_eyebrow: "आप क्या बुक कर सकते हैं",
    srv_h2: "इंसानी मदद, आसान कैटेगरी में।",
    srv_p: "कोई भारी-भरकम कैटलॉग नहीं। जो फिट हो चुनें \u2014 या बस अपना काम बताएं।",
    srv_cta: "बताइए क्या चाहिए",

    fest_eyebrow: "त्योहार, फ़ंक्शन और मेहमान",
    fest_h2: "इस त्योहार, सब कुछ अकेले मत कीजिए।",
    fest_p: "सजावट, घर पर मेहमान, पूजा और फ़ंक्शन में मदद, आख़िरी मिनट के काम और परिवार की मदद। घंटे के हिसाब से CHELA बुक करें।",

    how_eyebrow: "CHELA कैसे काम करता है",
    how_h2: "बस चार स्टेप।",
    how_1_t: "बताइए क्या चाहिए",
    how_1_d: "सर्विस चुनें या अपना काम लिखें।",
    how_2_t: "समय चुनें और पेमेंट करें",
    how_2_d: "स्लॉट चुनें और ऑनलाइन पेमेंट करें। आपका पता अपने-आप ले लिया जाता है और बुकिंग तुरंत कन्फ़र्म।",
    how_3_t: "हम मैच करते हैं",
    how_3_d: "उपलब्धता व काम के अनुसार उपयुक्त CHELA असाइन।",
    how_4_t: "काम पूरा",
    how_4_d: "आपका CHELA काम पूरा करने में मदद करता है।",

    trust_eyebrow: "भरोसा व सुरक्षा",
    trust_h2: "जिन पर आप भरोसा कर सकें।",
    trust_p: "आप अपने घर या परिवार में किसी को बुला रहे हैं। हम इसे गंभीरता से लेते हैं \u2014 हर CHELA पहले जॉब से पहले वेरिफ़ाई होता है।",
    soon: "जल्द आ रहा है",
    live_label: "लाइव",
    never_title: "एक CHELA कभी नहीं करेगा:",
    never_1: "आपका कैश या UPI PIN नहीं संभालेगा",
    never_2: "निजी कमरों में नहीं जाएगा",
    never_3: "आपका नंबर या पता किसी से साझा नहीं करेगा",
    never_4: "चिकित्सा सेवा नहीं देगा",
    never_allow: "CHELA सिर्फ़ उन्हीं जगहों में जाता है जहाँ आप अनुमति देते हैं।",
    trust_i1: "ID, सेल्फ़ी और रेफ़रेंस वेरिफ़ाइड",
    trust_i2: "साफ़, पारदर्शी कीमत",
    trust_i3: "बुकिंग कन्फ़र्मेशन",
    trust_i4: "कस्टमर सपोर्ट संपर्क",
    trust_i5: "बैकग्राउंड वेरिफ़िकेशन",
    trust_i6: "रेटिंग व रिव्यू सिस्टम",
    trust_note: "हर CHELA की पहले जॉब से पहले ID, सेल्फ़ी, लोकल रेफ़रेंस और बैकग्राउंड वेरिफ़िकेशन होता है।",
    flow_1: "बुक करें और लोकेशन शेयर करें",
    flow_2: "ऑनलाइन पेमेंट (UPI / कार्ड)",
    flow_3: "CHELA पहुँचता है",
    flow_4: "काम पूरा, CHELA को रेटिंग दें",
    unmute: "आवाज़ के लिए टैप करें",

    pr_eyebrow: "कीमतें",
    pr_h2: "आसान, साफ़ कीमतें।",
    pr_first_hour: "पहला घंटा",
    pr_then: "फिर",
    pr_note: "पहले घंटे में हेल्पर का आना-जाना और सेटअप शामिल है, इसलिए अगले घंटे सस्ते हैं।",
    pr_calc_title: "कीमत कैलकुलेटर",
    pr_plan: "प्लान",
    pr_hours: "घंटे",
    pr_total: "अनुमानित कुल",
    pr_standard: "स्टैंडर्ड",
    why_eyebrow: "CHELA क्यों",
    why_h2: "CHELA क्यों चुनें",
    stock_note: "प्रतिनिधि स्टॉक फ़ुटेज, असली ग्राहक या हेल्पर नहीं।",
    seehow_h2: "देखिए कैसे काम करता है",
    pain_1_t: "पर्सनल असिस्टेंस",
    why_1_t: "पर्सनल असिस्टेंस",
    why_1_d: "कुछ घंटों के लिए आपका अपना हेल्पर: काम, फ़ॉलो-अप, पिक-अप और वो सब जिसके लिए आपके पास समय नहीं।",
    why_2_t: "परिवार की मदद",
    why_2_d: "घर-परिवार के लिए एक एक्स्ट्रा हाथ: मेहमान, छोटे काम, पिक-अप और वो सब जिसके लिए आपके पास समय नहीं।",
    why_3_t: "ज़रूरी काम (Errands)",
    why_3_d: "लाइन, बिल, काग़ज़, पार्सल और पिक-अप/ड्रॉप, जब आप ऑफिस या घर पर हों।",
    why_4_t: "घर की हल्की मदद",
    why_4_d: "पंखे-शेल्फ़ की हल्की धूल, सामान जमाना, डिलीवरी या रिपेयर वाले का इंतज़ार। घर की सफ़ाई नहीं।",
    no_cleaning: "घर की सफ़ाई (झाड़ू, पोछा, बाथरूम, किचन, बर्तन)।",
    not_included: "शामिल नहीं",
    why_5_t: "इवेंट और फ़ंक्शन",
    why_5_d: "पूजा, जन्मदिन और छोटे फ़ंक्शन में एक्स्ट्रा हाथ: सेटअप, मेहमान और भाग-दौड़।",
    pain_1_d: "आप शॉपिंग करते रहें, आपका CHELA हर बैग उठाएगा।",
    pain_2_t: "एक दिन में बहुत सारी दुकानें",
    pain_2_d: "आपका CHELA हर दुकान तक साथ चलेगा और खरीदारी व्यवस्थित रखेगा।",
    pain_3_t: "ऑफिस में बिज़ी, भाग-दौड़ का समय नहीं",
    pain_3_d: "आपका CHELA बैंक, बिल, पार्सल और लाइन का काम संभालेगा, आप अपना दिन जारी रखें।",
    pr_rule_1: "कम से कम बुकिंग 1 घंटे की है",
    pr_rule_2: "बुकिंग से 3 घंटे पहले तक कैंसिलेशन मुफ़्त",
    pr_rule_3: "इंतज़ार का समय भी बिल होता है",
    pr_rule_4: "CHELA को दूसरी जगह ले जाना है? ट्रैवल ₹3 प्रति किमी, ऑनलाइन पेमेंट",

    b2b_eyebrow: "बिज़नेस के लिए",
    b2b_h2: "बिज़नेस, हम आपके ग्राहकों की भी मदद कर सकते हैं।",
    b2b_p: "आपके ग्राहक 5 से 10 बैग लेकर निकलते हैं और उन्हें अभी और दुकानों पर जाना होता है। 'Shop with a CHELA' ऑफ़र करें, आपका कोई ख़र्च नहीं। आपकी दुकान से आई हर बुकिंग पर हम एक छोटा रेफ़रल फ़ीस साझा कर सकते हैं।",
    f_shop: "दुकान का नाम",
    f_owner: "मालिक का नाम",
    f_area: "मार्केट / एरिया",
    b2b_cta: "CHELA पार्टनर बनें",
    b2b_benefit: "पार्टनर लाभ में रेफ़रल सपोर्ट, ग्राहक सुविधा और डेडिकेटेड असिस्टेंस विकल्प शामिल हो सकते हैं।",

    city_eyebrow: "शहर उपलब्धता",
    city_h2: "और शहरों में आ रहे हैं।",
    city_p: "हम भोपाल से शुरू कर रहे हैं और शहर-दर-शहर बढ़ेंगे। आपका शहर अभी नहीं? वेटलिस्ट जॉइन करें \u2014 इससे हमें असली माँग वाले शहर में लॉन्च करने में मदद मिलती है।",
    join_waitlist: "वेटलिस्ट जॉइन करें",

    faq_eyebrow: "सवाल",
    faq_h2: "जानना अच्छा रहेगा।",

    final_h2: "कुछ निपटाना है?",
    final_p: "एक CHELA लीजिए।",

    foot_tag: "आपका अतिरिक्त मददगार हाथ।",
    foot_rights: "CHELA. अब भोपाल में लाइव।",
    foot_join: "CHELA के साथ काम करें",
    foot_address: "CHELA, भोपाल, मध्य प्रदेश",
    foot_disclaimer: "CHELA हल्की, ग़ैर-चिकित्सा लोकल मदद देता है। हम पैकर्स-मूवर्स, कूरियर, नर्सिंग, सिक्योरिटी या टैक्सी सेवा नहीं हैं, और घर की सफ़ाई, पेंटिंग या डीप क्लीनिंग नहीं करते।",
    terms: "नियम",
    privacy: "प्राइवेसी",
    safety: "सुरक्षा व अस्वीकरण",

    bk_title: "एक CHELA बुक करें",
    s_what: "आपको क्या मदद चाहिए?",
    s_when: "कब?",
    s_where: "कहाँ और किसके लिए?",
    d_today: "आज",
    d_tomorrow: "कल",
    d_other: "दूसरी तारीख़",
    t_exact: "अपना सही घंटा चुनें (या इस स्लॉट में कभी भी)",
    t_any: "इस स्लॉट में कभी भी",
    slot_pick: "समय चुनें",
    f_more: "+ ईमेल, रेफ़रल कोड या शहर जोड़ें (वैकल्पिक)",
    f_less: "वैकल्पिक जानकारी छुपाएँ",
    bk_sub: "1 मिनट में बुक करें। ऑनलाइन पेमेंट करें और आपका CHELA आपके दरवाज़े पर पहुँचेगा।",
    f_city: "शहर",
    f_service: "सर्विस",
    f_desc: "बताइए क्या चाहिए",
    f_desc_ph: "जैसे: पिताजी के साथ बैंक जाना, फिर एक पार्सल लाना",
    f_date: "तारीख़",
    f_time: "समय स्लॉट",
    f_duration: "अवधि",
    f_location: "आपका पता",
    f_location_ph: "मकान नं., गली, लैंडमार्क, एरिया (जैसे अरेरा कॉलोनी)",
    f_name: "आपका नाम",
    f_phone: "फ़ोन नंबर",
    f_email: "रसीद के लिए ईमेल (वैकल्पिक)",
    f_email_ph: "you@email.com",
    f_ref: "स्टोर / रेफ़रल कोड (वैकल्पिक)",
    f_ref_ph: "जैसे SAREE-1A2B",
    f_select: "चुनें",
    submit_book: "पेमेंट करें और बुक करें",
    pay_note: "प्रीपेड बुकिंग। UPI (PhonePe, Google Pay, Paytm), कार्ड या नेटबैंकिंग से पेमेंट करें।",
    pay_opening: "पेमेंट खुल रहा है…",
    pay_pending: "पेमेंट पूरा नहीं हुआ। पेमेंट के बाद ही बुकिंग कन्फ़र्म होती है। दोबारा कोशिश करें।",
    loc_btn: "मेरी लोकेशन पता करें",
    loc_busy: "आपकी लोकेशन पता की जा रही है…",
    loc_ok: "लोकेशन मिल गई",
    loc_view: "मैप पर देखें",
    loc_again: "अपडेट करें",
    loc_err: "लोकेशन नहीं मिल पाई। लोकेशन की अनुमति दें या पता लिखें।",
    loc_need: "कृपया लोकेशन की अनुमति दें या पता लिखें।",
    ty_title: "CHELA बुक करने के लिए धन्यवाद!",
    ty_sub: "आपका पेमेंट मिल गया है और बुकिंग कन्फ़र्म है। आपका CHELA चुने हुए समय पर आपकी लोकेशन पर पहुँचेगा।",
    ty_paid: "भुगतान राशि",
    ty_when: "समय",
    ty_ref: "बुकिंग ID",
    ty_wa: "WhatsApp पर बात करें",
    ty_track: "अपने CHELA को ट्रैक करें",
    bk_success: "रिक्वेस्ट मिल गई। हम जल्द ही WhatsApp पर आपका CHELA कन्फ़र्म करेंगे। जब तक हम मैसेज न करें, बुकिंग कन्फ़र्म नहीं है।",
    bk_estimate: "अनुमानित राशि:",
    pay_now: "अभी पेमेंट करें",
    paylink_title: "अपनी CHELA बुकिंग पूरी करें",
    paylink_paid: "पेमेंट मिल गया। आपकी बुकिंग कन्फ़र्म है।",
    paylink_expired: "यह समय स्लॉट निकल चुका है। कृपया नया स्लॉट बुक करें।",
    paylink_bad: "यह पेमेंट लिंक सही नहीं है।",
    pay_pending_title: "पेमेंट बाकी है — आपका CHELA अभी बुक नहीं हुआ है। कन्फ़र्म करने के लिए अभी पेमेंट करें।",
    bk_rules: "बुकिंग से 3 घंटे पहले तक मुफ़्त कैंसिलेशन। इंतज़ार का समय बिल होता है। CHELA को दूसरी जगह ले जाने पर ₹3 प्रति किमी, ऑनलाइन पेमेंट।",
    slot_hint: "पहले तारीख़ चुनें, फिर समय स्लॉट।",
    slot_soon: "आज के जो स्लॉट निकल चुके हैं, वे उपलब्ध नहीं हैं।",
    other_city: "भोपाल में नहीं? वेटलिस्ट जॉइन करें",
    phone_err: "सही 10 अंकों का भारतीय मोबाइल नंबर डालें",
    link_terms: "नियम (Terms)",
    link_privacy: "प्राइवेसी",
    continue_wa: "WhatsApp पर जारी रखें",
    bk_only_bhopal: "हम भोपाल में लाइव हैं। अन्य शहरों के लिए नीचे वेटलिस्ट जॉइन करें।",

    wl_title: "सिटी वेटलिस्ट जॉइन करें",
    wl_use: "CHELA का उपयोग किस लिए करेंगे?",
    wl_submit: "वेटलिस्ट जॉइन करें",
    wl_success: "आप लिस्ट में हैं! आपके शहर में CHELA आने पर संपर्क करेंगे।",

    pt_title: "CHELA पार्टनर बनें",
    pt_sub: "आपके ग्राहक 5 से 10 बैग लेकर निकलते हैं और उन्हें अभी और दुकानों पर जाना होता है। 'Shop with a CHELA' ऑफ़र करें, आपका कोई ख़र्च नहीं। आपकी दुकान से आई हर बुकिंग पर हम एक छोटा रेफ़रल फ़ीस साझा कर सकते हैं।",
    f_business: "बिज़नेस का नाम",
    f_biz_type: "बिज़नेस टाइप",
    f_contact: "संपर्क व्यक्ति",
    f_message: "संदेश (वैकल्पिक)",
    pt_submit: "पार्टनर एन्क्वायरी भेजें",
    pt_success: "धन्यवाद! पार्टनरशिप के बारे में हम संपर्क करेंगे।",

    required: "यह ज़रूरी है",
    consent_err: "कृपया नियम और प्राइवेसी पॉलिसी से सहमति के लिए बॉक्स पर टिक करें",
    back_home: "होम पर वापस",
    install_title: "CHELA को होम स्क्रीन पर जोड़ें",
    install_sub: "एक टैप में मददगार हाथ बुक करें।",
    install_btn: "CHELA इंस्टॉल करें",
    install_ios: "Share आइकन दबाएँ, फिर \u2018Add to Home Screen\u2019 चुनें।",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("chela_lang") || "en");

  useEffect(() => {
    localStorage.setItem("chela_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = useCallback((key) => (STR[lang] && STR[lang][key]) || STR.en[key] || key, [lang]);
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "hi" : "en")), []);

  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
